import React from 'react';

import {WillAnimate} from '../components/content_animate';
import {Layout} from '../components/layout';
import {NumberHero} from '../components/number_hero';
import {ScrollTo} from '../components/scroll_to';

export default ({data}: any) => {
    return (
        <Layout
            title="Een gespecialiseerd team van software engineers die software ontwikkelde voor ondernemers."
            ogImage="homepage.png"
            translatedPagePath="/en/">
            <WillAnimate as="div" name="hero" className="hero--home" id="hero">
                <div className="hero__content-wrapper">
                    <div className="hero__content">
                        <h1>
                            Wij <br />
                            <span className="highlight">waren</span> <br />
                            Label305
                        </h1>
                        <h2>
                            Sinds 2010 ontwikkelden we gebruiksvriendelijke software <br />
                            en maakten we complexe processen eenvoudig.
                        </h2>
                    </div>
                </div>
                <ScrollTo className="hero__scroll" target="/#from-hero" position="start" />

                <NumberHero />
            </WillAnimate>

            <section className="section">
                <WillAnimate id="from-hero">
                    <div className="container">
                        <div className="content__display">
                            <h2>
                                15 jaar <br />
                                software
                                <br /> consultancy
                            </h2>
                        </div>
                        <div className="content__copy">
                            <p className="p-lead">
                                Per <strong>1 juni 2025</strong> zijn wij <strong className="highlight">gestopt</strong>{' '}
                                met de dienstverlening van Label305.
                            </p>
                            <p>We kijken met trots terug op 15 jaar software consultancy met een geweldig team.</p>
                            <p>
                                Van web-platforms tot apps, van sport en automotive tot taxeren: Label305 was dé{' '}
                                consultancy voor ondernemers.
                            </p>
                            <p>
                                De gebruiker stond altijd voorop: we maakten complexe processen eenvoudig, besteedden{' '}
                                veel aandacht aan de gebruikers­ervaring, en realiseerden software die gemakkelijk te{' '}
                                gebruiken is.
                            </p>
                            <p>
                                Van een klein team, gevestigd op de campus van Universiteit Twente, groeiden we naar een{' '}
                                team van 22 specialisten met een kantoor in Amsterdam en Enschede. In 2021 schaalden we{' '}
                                terug naar een klein en hecht team gevestigd aan de Hengelosestraat.
                            </p>
                            <p>
                                Wij kijken terug op een fantastische tijd en bedanken iedereen die ons heeft geholpen of{' '}
                                waar wij mee hebben samengewerkt.
                            </p>
                        </div>
                    </div>
                </WillAnimate>
            </section>
        </Layout>
    );
};
